export default "__VITE_ASSET__DbhistS1__"